import _ from "lodash";
import store from "@state/store";
import { checkIfNotSuperAndAdministrator } from "@utils/roles";

export const oneYearFromNow = new Date(
  new Date().setFullYear(new Date().getFullYear() + 1)
);

// set obj. to a new set of values
export const setObjectValues = (obj, val) => {
  if (obj) {
    Object.keys(obj).forEach((k) => {
      obj[k] = val;
    });
  }
};

export const chartOptions = {
  chart: {
    type: "line",
    height: 400,
    zoom: {
      enabled: true,
      type: "x"
    },
  },
  colors: [
    "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728",
    "#9467bd", "#8c564b", "#e377c2"
  ],
  // plotOptions: {
  //   bar: {
  //     dataLabels: {
  //       position: "top",
  //     },
  //     horizontal: false,
  //     columnWidth: "40%",
  //     endingShape: "rounded",
  //   },
  // },
  dataLabels: {
    enabled: true,
    formatter(val, { seriesIndex }) {
      const units = [
        "%RH", "°C", "us/cm", "PH",
        "mg/kg", "mg/kg", "mg/kg"
      ];
      return `${val} ${units[seriesIndex] || ""}`;
    },
    offsetY: -20,
    style: {
      fontSize: "12px",
      colors: ["#304758"],
    },
  },
  stroke: {
    show: true,
    width: 3,
    colors: ["transparent"],
  },
  xaxis: {
    categories: [],
    title: {
      text: "Time",
    },
  },
  yaxis: {
    title: {
      text: "Sensor Values",
    },
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    y: {
      formatter(val, { seriesIndex }) {
        const units = [
          "%RH", "°C", "us/cm", "PH",
          "mg/kg", "mg/kg", "mg/kg"
        ];
        return `${val} ${units[seriesIndex] || ""}`;
      },
    },
  },
  legend: {
    position: 'bottom'
  }
};

export const chartOptionsAsLine = {
  chart: {
    type: "line",
    height: 400,
    zoom: {
      enabled: true,
      type: "x"
    },
  },
  zoom: { enabled: true, type: 'x', autoScaleYaxis: true },
  colors: [
    "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728",
    "#9467bd", "#8c564b", "#e377c2"
  ],
  dataLabels: {
    enabled: false,
    formatter(val, { seriesIndex }) {
      const units = [
        "%RH", "°C", "us/cm", "",
        "mg/kg", "mg/kg", "mg/kg"
      ];
      return `${val} ${units[seriesIndex] || ""}`;
    },
    offsetY: -10,
    style: {
      fontSize: "12px",
      colors: ["#304758"],
    },
  },
  stroke: {
    show: true,
    width: 3,
    curve: 'smooth',
  },
  xaxis: {
    categories: [],
    title: {
      text: "Time",
    },
  },
  yaxis: {
    title: {
      text: "Sensor Values",
    },
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    y: {
      formatter(val, { seriesIndex }) {
        const units = [
          "%RH", "°C", "us/cm", "",
          "mg/kg", "mg/kg", "mg/kg"
        ];
        return `${val} ${units[seriesIndex] || ""}`;
      },
    },
  },
  legend: {
    position: 'bottom'
  },
  events: {
    zoomed: function (chartContext, { xaxis }) {
      if (onZoomCallback) {
        const startDate = new Date(xaxis.min).toISOString();
        const endDate = new Date(xaxis.max).toISOString();
        onZoomCallback({ startDate, endDate });
      }
    },
    selection: function (chartContext, { xaxis }) {
      if (onZoomCallback) {
        const startDate = new Date(xaxis.min).toISOString();
        const endDate = new Date(xaxis.max).toISOString();
        onZoomCallback({ startDate, endDate });
      }
    },
  },
};

export function getChartOptions(onZoomCallback) {
  return {
    chart: {
      type: "line",
      height: 400,
      zoom: {
        enabled: true,
        type: "x",
        zoomedArea: {
          fill: {
            color: "#90CAF9",
            opacity: 0.4,
          },
          stroke: {
            color: "#0D47A1",
            opacity: 0.4,
            width: 1,
          },
        },
        autoScaleYaxis: true,
        zoomOnMouseWheel: false, // 👈 disables zoom on scroll
        zoomOnTouch: true,
      },
      events: {
        zoomed(chartContext, { xaxis }) {
          if (onZoomCallback && xaxis.min && xaxis.max) {
            const startDate = new Date(xaxis.min).toISOString();
            const endDate = new Date(xaxis.max).toISOString();
            onZoomCallback({ startDate, endDate });
          }
        },
        selection(chartContext, { xaxis }) {
          if (onZoomCallback && xaxis.min && xaxis.max) {
            const startDate = new Date(xaxis.min).toISOString();
            const endDate = new Date(xaxis.max).toISOString();
            onZoomCallback({ startDate, endDate });
          }
        },
      },
    },
    colors: [
      "#1f77b4", "#ff7f0e", "#2ca02c", "#d62728",
      "#9467bd", "#8c564b", "#e377c2"
    ],
    dataLabels: {
      enabled: false,
      formatter(val, { seriesIndex }) {
        const units = [
          "%RH", "°C", "us/cm", "",
          "mg/kg", "mg/kg", "mg/kg"
        ];
        return `${val} ${units[seriesIndex] || ""}`;
      },
      offsetY: -10,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },
    stroke: {
      show: true,
      width: 3,
      curve: 'smooth',
    },
    xaxis: {
      categories: [],
      title: {
        text: "Time",
      },
    },
    yaxis: {
      title: {
        text: "Sensor Values",
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter(val, { seriesIndex }) {
          const units = [
            "%RH", "°C", "us/cm", "",
            "mg/kg", "mg/kg", "mg/kg"
          ];
          return `${val} ${units[seriesIndex] || ""}`;
        },
      },
    },
    legend: {
      position: 'bottom'
    },
  };
}

export const chartClientOptions = {
  chart: {
    type: "line",
    // zoom: {
    //   enabled: true,
    //   type: "x"
    // },
    dropShadow: {
      enabled: true,
      color: '#000',
      top: 18,
      left: 7,
      blur: 10,
      opacity: 0.2
    },
    zoom: {
      enabled: false,
      type: "x"
    },
    toolbar: {
      show: false,
      tools: {
        zoom: false,
        zoomin: false,
        zoomout: false,
        pan: false,
        reset: true
      }
    }
  },
  // colors: ['#77B6EA', '#545454'],
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    curve: 'smooth',
  },
  title: {
    text: '',
    align: 'left'
  },
  grid: {
    borderColor: '#e7e7e7',
    row: {
      colors: ['#f3f3f3', 'transparent'],
      opacity: 0.5
    },
  },
  // markers: {
  //   size: 1
  // },
  xaxis: {
    categories: [],
  },
  yaxis: {
    title: {
      text: "",
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: 'bottom'
  }
};

export const chartBatteryOptions = {
  chart: {
    type: "line",
    height: 400,
  },
  colors: ["#e67e22", "#1abc9c"],
  dataLabels: {
    enabled: false,
    formatter(val, { seriesIndex }) {
      const units = ["mV", "mV"];
      return `${val} ${units[seriesIndex] || ""}`;
    },
    offsetY: -20,
    style: {
      fontSize: "12px",
      colors: ["#304758"],
    },
  },
  stroke: {
    show: true,
    width: 3,
    curve: 'smooth',
  },
  xaxis: {
    categories: [], // Set dynamically
    title: {
      text: "Time",
    },
  },
  yaxis: {
    title: {
      text: "mV",
    },
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    y: {
      formatter(val) {
        return `${val} mV`;
      },
    },
  },
  legend: {
    position: 'bottom'
  }
};

export const upperCaseFirstLetters = (string) => {
  return _.startCase(_.toLower(string));
};

export const computeSelectedCostCenterId = (selectedCostCenterId) => {
  if (checkIfNotSuperAndAdministrator()) {
    return `?by_cost_center_id=${store.state.auth.user.selected_cost_center.id}`;
  } else {
    return selectedCostCenterId !== ""
      ? `?by_cost_center_id=${selectedCostCenterId}`
      : "";
  }
};

export const computeDateRange = (dateRange) => {
  return dateRange && dateRange.length > 0
    ? `by_date_range[start_date]=${dateRange[0]}&by_date_range[end_date]=${dateRange[1]}`
    : "";
};

export const computeTimeToUTC = (created_at) => {
  return `${new Date(created_at).getHours()}:${new Date(created_at).getMinutes()}:${new Date(created_at).getSeconds()}`;
};

export const computeDateRangeWithSelectedCostCenterId = (
  selectedCostCenterId,
  dateRange
) => {
  const computedCostCenterId =
    computeSelectedCostCenterId(selectedCostCenterId);
  const computedDateRange = computeDateRange(dateRange);

  return computedCostCenterId !== ""
    ? computedCostCenterId + `&${computedDateRange}`
    : `?${computedDateRange}`;
};


export const joinValuesWithComma = (valuesArray) => {
  return valuesArray.join(", ");
};
